function openMiniCart() {
    const cartDrawer = document.getElementById('CartDrawer');
    const cartOverlay = document.getElementById('CartDrawer-Overlay');
    const cart_drawer = document.querySelector("body > cart-drawer");
    const cart_drawer_items = document.querySelector("cart-drawer-items");

    // Adiciona classes para exibir o minicart
    cartDrawer.classList.add('is-visible');
    cartOverlay.classList.add('is-visible');
    cart_drawer.classList.add('active');
    cart_drawer.classList.remove('is-empty');
    cart_drawer_items.classList.remove('is-empty');

    let cartEmpty = document.querySelector('.drawer__inner-empty')

    if (cartEmpty) {
        cartEmpty.style.display = 'none';
    }


    fetch('/cart?view=drawer').then(response => response.text()).then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const cartContents = doc.querySelector('.drawer__inner').innerHTML;
        document.querySelector('.drawer__inner').innerHTML = cartContents;

        fetch('/cart.js', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(response => {
            if (!response.ok) throw response;
            return response.json();
        }).then(data => {
            let updatedQuantity = data.item_count ?? 0;
            document.getElementById('cart_count_desk').textContent = updatedQuantity;
        });
    }).catch(error => console.error('Erro ao carregar o minicart:', error));
}